import { Button, Form, FormSelect, Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../../@ui/StyledModalTitle";
import { Formik } from "formik";
import { LicenceTypeSummary } from "../../../../types/Licences/LicenceTypeSummary";
import { LicenceTypeUpdateRequest } from "../../../../types/Licences/LicenceTypeUpdateRequest";
import LayerCheckboxes from "../Forms/LayerCheckboxes";
import { ErrorText } from "../../../../@ui/ErrorText";
import { EditSchema } from "./EditSchema";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";

interface LicenceEditModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (values: LicenceTypeUpdateRequest) => void;
  licenceTypeSummary: LicenceTypeSummary;
}

const LicenceTypeEditModal = ({
  show,
  onClose,
  onSubmit,
  licenceTypeSummary,
}: LicenceEditModalProps) => {
  const initialValues = { id: undefined } as LicenceTypeUpdateRequest;

  const onLicenceTypeSelect = (
    e: any,
    handleChange: (e: any) => void,
    setValues: (values: LicenceTypeUpdateRequest) => void
  ) => {
    const licenceTypeId = e.target.value;
    const licenceType = licenceTypeSummary.licenceTypes.find(
      (lt) => lt.id === parseInt(licenceTypeId)
    );

    setValues({
      ...initialValues,
      accessibleLayerIds: licenceType?.accessibleLayers.map((al) => al.id),
      hasTomTomAccess: licenceType?.hasTomTomAccess,
    });
    handleChange(e);
  };

  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        validationSchema={EditSchema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          values,
          setValues,
          handleSubmit,
          handleChange,
          touched,
          errors,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>Update Licence Access</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <FormSelect
                  value={values.id}
                  onChange={(e) => {
                    onLicenceTypeSelect(e, handleChange, setValues);
                  }}
                  onBlur={handleBlur}
                  name="id"
                >
                  <option value={""}>Select Licence Type</option>
                  {licenceTypeSummary.licenceTypes.map((lt, index) => (
                    <option key={index} value={lt.id}>
                      {lt.name}
                    </option>
                  ))}
                </FormSelect>
                {errors.id && touched.id && (
                  <ErrorText className="text-danger px-1">
                    {errors.id}
                  </ErrorText>
                )}
              </Form.Group>

              <LayerCheckboxes
                visible={
                  values.accessibleLayerIds != null &&
                  values.hasTomTomAccess != null
                }
                layers={licenceTypeSummary.layers}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default LicenceTypeEditModal;
